// src/store/slices/teamSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import teamApi from 'api/teamApi';

export const fetchMyTeam = createAsyncThunk(
  'team/fetchMyTeam',
  async ({ page = 1, pageSize = 10, search = '' }, { rejectWithValue }) => {
    try {
      const response = await teamApi.getMyTeam(page, pageSize, search);
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data?.detail || 'Failed to load team');
    }
  }
);

const teamSlice = createSlice({
  name: 'team',
  initialState: {
    members: [],
    pagination: { count: 0, page_size: 10, next: null, previous: null },
    isLoading: false,
    error: null,
    // requestId of the most recent fetch; replies from older fetches (e.g. while the user
    // is still typing in search) are ignored so a slow earlier response can't overwrite it.
    latestRequestId: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMyTeam.pending, (state, action) => {
        state.latestRequestId = action.meta.requestId;
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchMyTeam.fulfilled, (state, action) => {
        if (action.meta.requestId !== state.latestRequestId) return;
        state.isLoading = false;
        state.members = action.payload.data;
        state.pagination = action.payload.pagination;
      })
      .addCase(fetchMyTeam.rejected, (state, action) => {
        if (action.meta.requestId !== state.latestRequestId) return;
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export const { clearError } = teamSlice.actions;
export default teamSlice.reducer;